var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.value.title))]),_c('v-rating',{attrs:{"value":_vm.value.rating,"length":"5","empty-icon":"mdi-circle-outline","full-icon":"mdi-circle","half-icon":"mdi-circle-half-full","readonly":true,"size":26,"dense":true,"color":"blue-grey lighten-3","background-color":"grey lighten-1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }